import { Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import { lazy } from "react";

const ScenarioDashboard = lazy(() => import("./components/ScenarioDashboard"));
const ScenarioView = lazy(() => import("./components/ScenarioView"));
const NotFoundPage = lazy(() => import("./components/NotFoundPage"));

export function LoggedInRouter() {
  const routes = [
    {
      path: "/",
      element: <ScenarioDashboard />,
    },
    {
      path: "/scenario/:scenarioId",
      element: <ScenarioView />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ];

  return (
    <Suspense fallback={<div />}> 
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Suspense>
  );
}
